export UserSummary from './UserSummary';



// WEBPACK FOOTER //
// ../src/client/components/UserSummary/index.js